import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { fileUrl } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function Lightbox({ photos, index, onIndex, onClose }) {
  const open = index !== null && index !== undefined && photos?.length > 0;
  const p = open ? photos[index] : null;
  const go = (d) => onIndex((index + d + photos.length) % photos.length);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl border-2 border-ink bg-ink p-2 text-white" data-testid="lightbox">
        <DialogTitle className="sr-only">Foto bukti</DialogTitle>
        {p && (
          <div>
            <div className="relative">
              <img src={fileUrl(p.id)} alt="foto bukti" className="max-h-[75vh] w-full rounded object-contain" data-testid="lightbox-image" />
              {photos.length > 1 && (
                <>
                  <button onClick={() => go(-1)} className="absolute left-2 top-1/2 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-white text-ink" data-testid="lightbox-prev"><ChevronLeft /></button>
                  <button onClick={() => go(1)} className="absolute right-2 top-1/2 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-white text-ink" data-testid="lightbox-next"><ChevronRight /></button>
                </>
              )}
            </div>
            <div className="flex justify-between px-2 py-2 text-xs text-zinc-300">
              <span>Diunggah {p.uploaded_by_name || "-"} · {fmtDateTime(p.uploaded_at)}</span>
              <span className="num">{index + 1}/{photos.length}</span>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
